import { SERVICE_MASTER_STATUS, TOwnerAutoSuggestService } from "@elixir/types";
import { GET_AXON_HOST } from "../../constants/env";
import fetch from "../../fetch-client";
import { AxonGenericApiResponse } from "../../types/axon";

export type TGetOwnerServicesAutosuggestRequestProps = {
  q?: string;
  page?: number;
  pageSize?: number;
  status?: SERVICE_MASTER_STATUS;
  clinic_id?: string;
  searchInAllServiceTypes?: boolean;
};

export default async function getServicesMasterAutosuggest({
  q,
  page,
  pageSize,
  status = SERVICE_MASTER_STATUS.ACTIVE,
  clinic_id,
  searchInAllServiceTypes,
}: TGetOwnerServicesAutosuggestRequestProps): Promise<
  AxonGenericApiResponse<TOwnerAutoSuggestService[]>
> {
  const AXON_HOST = GET_AXON_HOST();
  const requestOptions: RequestInit = {
    method: "GET",
    redirect: "follow",
    credentials: "include",
    mode: "cors",
  };
  const url = new URL(`${AXON_HOST}/autosuggest/services-master`);
  if (q) {
    url.searchParams.set("q", q);
  }
  if (page) {
    url.searchParams.set("page", page.toString());
  }
  if (pageSize) {
    url.searchParams.set("page_size", pageSize.toString());
  }
  if (searchInAllServiceTypes) {
    url.searchParams.set("status", "ALL");
  } else {
    if (status) {
      url.searchParams.set("status", status.toString());
    }
  }

  if (clinic_id) {
    url.searchParams.set("clinic_id", clinic_id.toString());
  }
  const response = await fetch(url.toString(), requestOptions);
  return await response.json();
}
